import { render, staticRenderFns } from "./detail-bundle.vue?vue&type=template&id=5d94975c&"
import script from "./detail-bundle.vue?vue&type=script&lang=js&"
export * from "./detail-bundle.vue?vue&type=script&lang=js&"
import style0 from "./detail-bundle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports